import Vue from 'vue';
import moment_tz from 'moment-timezone'

const moment = require('moment');
moment.suppressDeprecationWarnings = true;

Vue.prototype.isContains = function (word, arry) {
  const list = arry ? arry : [];
  return list.some((item, i) => {
    if (item == word) {
      return true
    }
  })
};

const timeZone = sessionStorage.getItem('zoneId');


export default {
  formatMoney8(s, incomeCommission, revenueType) {
    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }

    if (revenueType === 1) {
      s = (s * incomeCommission).toFixed(2)
    } else {
      s = (s - (s * incomeCommission)).toFixed(2)
      //console.log('ssssssssssssssssssssssssssssss')
      //console.log(s)
    }
    let type;
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-$${s.split('-')[1]}`
    else
      s = `+$${s}`
    return s;
  },
  alert(titles, msg, type) {
    // Vue.prototype.$message ({
    //     showClose: true,
    //     message: msg,
    //     type: type,
    //     duration:3000
    // })

    // console.assert(msg == '', msg)
  },
  alert2(titles, msg, type, duration = 3000) {
    Vue.prototype.$message({
      showClose: true,
      message: msg,
      type: type,
      duration: duration
    })
  },
  timeToCompare(start, end, type) {
    const startNew = Date.parse(new Date(`2021/01/01 ${start}`))
    const endNew = Date.parse(new Date(`2021/01/01 ${end}`))
    if (type == 'end') {
      if (endNew < startNew) {
        return false
      } else {
        return true
      }
    }
  },
  isIntNum(val) {
    var reg = /^\d{1,}$/
    var pattern = new RegExp(reg);
    return pattern.test(val);
  },
  loadings(n) {
    Vue.prototype.$loading({
      lock: true,
      text: '',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.4)',
      target: document.querySelector('body')
    });
    if (n == 2) {
      var loading = Vue.prototype.$loading({});
      loading.close()
    }
  },
  loadingsWithText(options, n) {
    Vue.prototype.$loading({
      lock: true,
      text: options.text,
      customClass: options.customClass,
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.4)',
      target: document.querySelector('body')
    });
    if (n == 2) {
      var loading = Vue.prototype.$loading({});
      loading.close()
    }
  },
  getPrice(val) {
    if (val) {
      let price = +val
      price = val.toFixed(2)
      val = price
    }
    let check = val ? val : ''
    let pos_decimal = String(check).split('.')
    let check_ = pos_decimal[1] ? pos_decimal[1].length : undefined
    let check_2 = pos_decimal[0] ? pos_decimal[0] : '0'
    let backtime = ''
    if (check_ == undefined) {
      backtime = (check_2 + '.00').trim()
    } else if (check_ == 1) {
      backtime = pos_decimal.join('.') + '0'
    } else if (check_ == 2) {
      backtime = pos_decimal.join('.')
    } else {
      let arr = pos_decimal[1].split('')
      backtime = check_2 + '.' + arr[0] + arr[1]
    }
    return String(backtime)
  },
  timestampToTime(timestamp) {
    let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '';
    let M = date.toString().split(' ')[1] + ' '
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    let H = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
    if (H - 12 < 0) {
      H = H + ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ' AM';
    } else if (H - 12 >= 0 && H - 24 < 0) {
      H = (H - 12) < 10 ? '0' + (H - 12) + ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ' PM' : (H - 12) + ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ' PM';
    } else if (H - 24 == 0) {
      H = '00' + ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ' PM';
    }
    return D + M + Y;
  },
  timeFormat(val) {
    if (val.toString().split('').length == 10) {
      val = Number(val) * 1000
    }
    let date = (new Date(val));
    if (!date) {
      date = Date.now()
    }
    const time = date.toLocaleDateString().replace(/\//g, "/") + " " + date.toTimeString().substr(0, 8)
    return time
  },
  timeFormatTem(val) {
    let date = new Date(val * 1000);
    if (!date) {
      date = Date.now()
    }
    const time = date.toLocaleDateString().replace(/\//g, "/") + " " + date.toTimeString().substr(0, 5)
    //console.log(date.toTimeString());
    return time
  },
  timeFotmatYMD(time) {
    if (!timeZone) {
      return
    }
    let timestamp = moment_tz(time).tz(timeZone ? timeZone : sessionStorage.getItem('zoneId')).format('DD/MM/yyyy')
    return timestamp
  },

  dateTimeGenerator(time) {
    let timestamp = moment_tz(time).tz(timeZone ? timeZone : sessionStorage.getItem('zoneId')).format('DD/MM/yyyy HH:mm')
    return timestamp
  },

  dateTimeGeneratorWithDay(time, tz = timeZone, format = 'ddd MMMM DD, yyyy') {
    let timestamp = moment_tz(time).tz(tz ? tz : timeZone).format(format)
    return timestamp
  },

  getDateFormat(time, format = 'DD-MMM-YY') {
    let timestamp = moment_tz(time).format(format)
    return timestamp
  },

  dateTimeGeneratorWithoutFormat(time, tz = timeZone) {
    let timestamp = moment_tz(time).tz(tz)
    return timestamp
  },

  getTimeOfTimezone(time, timezone = timeZone) {
    if (timezone == null) {
      timezone = timeZone
    }

    let timestamp = moment_tz(time).tz(timezone).format('HH:mm')
    return timestamp
  },

  timeFotmatDetail(time) {
    if (time === '0' || !time)
      return '-'
    if (typeof (time) === 'string')
      time = Number(time)
    if (time < 10000000000)
      time = time * 1000
    //console.log('time----------------------------------------------------------------------------------')
    //console.log(time)
    let timestamp = moment_tz(time).tz('Australia/sydney').format('HH:mm DD/MM/yyyy')
    let hour = timestamp.slice(0, 2)
    let amOrpm = 'am'
    if (Number(hour) > 12)
      amOrpm = 'pm'
    return `${timestamp.split(' ')[0]} ${amOrpm} ${timestamp.split(' ')[1]}`
  },
  timeFoDate(time) {
    let date = new Date(time);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = `0${m}`
    }
    let d = date.getDate();
    if (d < 10) {
      d = `0${d}`
    }
    return `${y}-${m}-${d}`
  },
  timeFormatYear(val) {
    let date = new Date(val * 1000);
    if (!date) {
      date = Date.now()
    }
    const time = date.toLocaleDateString().replace(/\//g, "/")
    return time
  },
  getWeek(val) {
    let week = ''
    switch (val) {
      case 1:
        week = '周一'
        break;
      case 2:
        week = '周二'
        break;
      case 3:
        week = '周三'
        break;
      case 4:
        week = '周四'
        break;
      case 5:
        week = '周五'
        break;
      case 6:
        week = '周六'
        break;
      case 7:
        week = '周日'
        break;
      default:
        week = '周一'
        break;
    }
    return week
  },
  getNowDate() {//获取当前时间
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getNowDateNew(time) {
    let date = date = new Date(`${time.split('/')[2]}-${time.split('/')[1]}-${time.split('/')[0]} 23:59:59`)
    let date1 = new Date();
    return Date.parse(date) < Date.parse(date1);
  },
  // 小数截断
  formatDecimal(num, decimal) {
    if (num === null) {
      return null
    }
    if (num == 0) {
      return '0.00'
    }
    num = num.toString()
    let index = num.indexOf('.')
    if (index !== -1) {
      num = num.substring(0, decimal + index + 1)
    } else {
      num = num.substring(0)
    }
    return parseFloat(num).toFixed(decimal)
  },
  formatSplit(s, type) {
    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s))
      s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    if (type == 0) {// 不带小数位(默认是有小数位)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    if (s.indexOf('.') === -1)
      s = s + '.00'
    return s;
  },
  formatNewHour(s, type) {
    if (s === null || s === undefined) {
      return '-'
    }
    if (s === "") {
      return '-';
    }
    if (s === 0) {
      return "0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s))
      s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    if (type == 0) {// 不带小数位(默认是有小数位)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-${s.split('-')[1]}h`
    else
      s = `+${s}h`
    return s;
  },

  formatDateMonthyear3(timestamp) {
    let date = new Date(timestamp * 1000);
    let M = date.getMonth() + 1
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    if (M === 1) {
      M = 'Jan'
    } else if (M === 2) {
      M = 'Feb'
    } else if (M === 3) {
      M = 'Mar'
    } else if (M === 4) {
      M = 'Apr'
    } else if (M === 5) {
      M = 'May'
    } else if (M === 6) {
      M = 'Jun'
    } else if (M === 7) {
      M = 'Jul'
    } else if (M === 8) {
      M = 'Aug'
    } else if (M === 9) {
      M = 'Sep'
    } else if (M === 10) {
      M = 'Oct'
    } else if (M === 11) {
      M = 'Nov'
    } else if (M === 12) {
      M = 'Dec'
    }
    return D + '-' + M;
  },
  formatDateMonthyear4(timestamp) {
    let date = new Date(timestamp * 1000);
    let M = date.getMonth() + 1
    let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    if (M === 1) {
      M = 'Jan'
    } else if (M === 2) {
      M = 'Feb'
    } else if (M === 3) {
      M = 'Mar'
    } else if (M === 4) {
      M = 'Apr'
    } else if (M === 5) {
      M = 'May'
    } else if (M === 6) {
      M = 'Jun'
    } else if (M === 7) {
      M = 'Jul'
    } else if (M === 8) {
      M = 'Aug'
    } else if (M === 9) {
      M = 'Sep'
    } else if (M === 10) {
      M = 'Oct'
    } else if (M === 11) {
      M = 'Nov'
    } else if (M === 12) {
      M = 'Dec'
    }
    return D + ' ' + M;
  },
  getDay2(time) {
    let timestamp = moment_tz(time).tz('Australia/sydney').format('YYYY-MM-DD')
    return new Date(timestamp).getDay()
  },
  formatGetWeek(time) {
    // console.log(moment_tz(time).tz('Australia/Sydney'))
    //console.log(moment_tz(time).tz('Australia/Sydney').day())
    return moment_tz(time).tz('Australia/Sydney').day()
  },
  formatDateMonth(time) {
    //console.log(time)
    let timestamp = moment_tz(time).tz('Australia/Sydney').format('YYYY-MM-DD')

    let M = Number(timestamp.split('-')[1])
    let D = timestamp.split('-')[2]
    if (M === 1) {
      M = 'Jan'
    } else if (M === 2) {
      M = 'Feb'
    } else if (M === 3) {
      M = 'Mar'
    } else if (M === 4) {
      M = 'Apr'
    } else if (M === 5) {
      M = 'May'
    } else if (M === 6) {
      M = 'Jun'
    } else if (M === 7) {
      M = 'Jul'
    } else if (M === 8) {
      M = 'Aug'
    } else if (M === 9) {
      M = 'Sep'
    } else if (M === 10) {
      M = 'Oct'
    } else if (M === 11) {
      M = 'Nov'
    } else if (M === 12) {
      M = 'Dec'
    }
    return M + ' ' + D;
  },
  getThis7Days() {// 获取本周的开始结束时间
    const start = moment().weekday(1).format('DD/MM/YYYY'); //本周一
    const end = moment().weekday(7).format('DD/MM/YYYY'); //本周日
    return [start, end]
  },
  formatMoney(s, type) {
    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    return s;
  },
  formatMoney3(s, type) {
    if (s === null || s === undefined || s == 'NaN' || s === 0) {
      // return null
      return "$0.00";
    }
    if (s === "") {
      return '';
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-$${s.split('-')[1]}`
    else
      s = `+$${s}`
    return s;
  },
  formatMoney6(s, type) {
    if (s === undefined || s == 'NaN') {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0 || s === null) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-$${s.split('-')[1]}`
    else
      s = `+$${s}`
    return s;
  },
  formatMoneyActual(s, type) {
    if (s === null || s === undefined) {
      return '-'
    }
    if (s === "") {
      return '-';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }

    if (!s) {
      return '-'
    }
    if (s == null || s == "" || s === undefined) {
      return '-';
    }
    
    // Convert to number and round to 2 decimal places
    let num = parseFloat(s);
    if (isNaN(num)) {
      return '-';
    }
    
    // Round to 2 decimal places
    s = num.toFixed(2);

    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-$${s.split('-')[1]}`
    else
      s = `+$${s}`
    return s;
  },
  formatMoneyLabour(s, type) {

    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    
    s = s < 0 && type === 0 ? s.toString().replace(/^(-?\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `-$${s.split('-')[1]}`
    else
      s = `$${s}`

    return s;
  },
  formatMoney99(s, type) {
    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    return s;
  },
  formatHourWithType(s, type) {
    if (type == 'hide-hour') {
      return '**h'
    }
    if (s === null)
      return '-'
    else
      return `${s}h`
  },
  formatHour(s) {
    if (s === null)
      return '-'
    else
      return `${s}h`
  },
  formatMoney5(s, type) {
    if (type == 'hide-cost') {
      return '$***.**'
    }
    if (type == 'hide-hour') {
      var a = s
      return '**h'
    }
    if (s == 0) {
      return "$0.00";
    }
    if (!s) {
      return '-'
    }
    if (s == null || s == "" || s === undefined) {
      return '-';
    }
    
    // Convert to number and round to 2 decimal places
    let num = parseFloat(s);
    if (isNaN(num)) {
      return '-';
    }
    
    // Round to 2 decimal places
    s = num.toFixed(2);
    
    // Handle the type parameter for no decimal places
    if (type == 0) {// No decimal places (default is decimal places)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    
    // Add thousands separators
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s))
      s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    
    // Ensure we have decimal places if needed
    if (s.indexOf('.') === -1 && type !== 0) {
      s = s + '.00'
    }
    
    // Handle negative numbers and add dollar sign
    if (s.indexOf('-') !== -1) {
      s = `-$${s.split('-')[1]}`
    }
    else {
      s = `$${s}`
    }
    
    return s;
  },
  formatMoney4(s, type) {

    if (s === null || s === undefined || s === 'NaN' || s === 'null' || s === 'undefined') {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    console.log('s1: ', s)
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    if (s.indexOf('-') !== -1)
      s = `$${s.split('-')[1]}`
    else
      s = `$${s}`
    return s;
  },
  formatMoney2(s, type) {
    if (s === null || s === undefined) {
      return null
    }
    if (s === "") {
      return '';
    }
    if (s === 0) {
      return "$0.00";
    }
    if (JSON.stringify(s).indexOf('.') === -1) {
      type = 0
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
    if (type !== -1 && s.split('.')[1].length > 2) {
      let xiaoshu = s.split('.')[1]
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      s = `${s.split('.')[0]}.${xiaoshu}`
    } else {
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
    }

    if (s.indexOf('.') === -1)
      s = s + '.00'
    else {
      let decimalPoint = s.split('.')[1]
      if (decimalPoint.length > 2) {
        let howManyShouldDelete = -(decimalPoint.length - 2)
        s = s.slice(0, howManyShouldDelete)
      }
    }
    s = s.indexOf('-') !== -1 ? `-$${s.split('-')[1]}` : `$${s}`
    return s;
  },
  getToday() {
    return {
      time: moment(new Date()).startOf('day').valueOf(),
      day: moment(new Date()).day()
    }
  },
  getTimeByDay(day, week) {
    let f = ''
    week.forEach(i => {
      if (day === i.day)
        f = i.time
    })
    return f
  },
  // 获取某个月的总天数
  getDaysOfMonth(year, month) {
    var date = new Date(year, month, 0);
    var days = date.getDate();
    return days;
  },
  // 传入指定日期，获取第二天的日期
  getNextDay(e) {
    let year = Number(e.split('/')[0])
    let month = Number(e.split('/')[1])
    let dd = Number(e.split('/')[2])
    let lastday = Utils.getDaysOfMonth(year, month)
    let next = dd + 1
    let result = ''
    if (next <= lastday) {
      let mm = month < 10 ? `0${month}` : month
      let d = next < 10 ? `0${next}` : next
      result = `${year}/${mm}/${d}`
    }
    else {
      if (month < 12) {
        let m1 = month + 1
        let m2 = m1 < 10 ? `0${m1}` : m1
        result = `${year}/${m2}/01`
      } else {
        result = `${year + 1}/01/01`
      }
    }
    return result
  },
  // 传入指定日期，获取未来7天（含今天）的日期
  getNextFewDays(e) {
    let results = []

    for (let i = 0; i < 7; i++) {
      if (i === 0)
        results.push(e)
      else {
        let last = results[i - 1]
        let current = Utils.getNextDay(last)
        results.push(current)
      }
    }
    return results
  },
  loadWeekDatum(start) {

    let temp = moment_tz(start * 1000).tz('Australia/sydney').format('yyyy/MM/DD')
    // 获取未来7天的日期(包含今天)
    let futureDays = Utils.getNextFewDays(temp)
    // let tempStamp = moment_tz(temp).tz('Australia/sydney').startOf('day').format('X')

    var currentWeek = []
    for (let i = 0; i < 7; i++) {
      // let temp = moment_tz(start * 1000).tz('Australia/sydney').format('yyyy/MM/DD')

      // 每天悉尼零点的时间戳
      let tempStamp = (moment_tz(futureDays[i]).tz('Australia/sydney').startOf('day').format('X')) * 1000
      let week = Utils.formatGetWeek(tempStamp)
      let day = ''
      if (week === 0) {
        day = 'sun'
      } else if (week === 5) {
        day = 'fri'
      } else if (week === 4) {
        day = 'thu'
      } else if (week === 3) {
        day = 'wed'
      } else if (week === 2) {
        day = 'tue'
      } else if (week === 1) {
        day = 'mon'
        // console.log(Utils.formatDateMonth(start * 1000 + ( i * 86400000 )))
      } else if (week === 6) {
        day = 'sat'
      }
      currentWeek.push({
        week: week,
        day: day,
        time: Utils.formatDateMonth(tempStamp)
      })
    }
    //console.log(currentWeek)
    return currentWeek
  },
  getWeekname(week) {
    let day = ''
    if (week === 7 || week === 0) {
      day = 'sun'
    } else if (week === 5) {
      day = 'fri'
    } else if (week === 4) {
      day = 'thu'
    } else if (week === 3) {
      day = 'wed'
    } else if (week === 2) {
      day = 'tue'
    } else if (week === 1) {
      day = 'mon'
      // console.log(Utils.formatDateMonth(start * 1000 + ( i * 86400000 )))
    } else if (week === 6) {
      day = 'sat'
    }
    return day
  },

  getWeekSelection(isfuture = null) {
    var currentDay = new Date()

    var weekNumber = this.getWeeks(currentDay);
    var res = []
    for (var i = 0; i < 5; i++) {
      var isPresent = false
      var weekValue = !isfuture ? weekNumber - i : weekNumber + i
      var d = ((weekValue) * 7); // 1st of January + 7 days for each week
      // Prev Developer
      // var lastDay = new Date(currentDay.getFullYear(), 0, d + 1, 23, 59, 59)
      // var firstDay = new Date(currentDay.getFullYear(), 0, d -  5, 0, 0, 0)
      var lastDay = new Date(currentDay.getFullYear(), 0, d, 23, 59, 59)
      var firstDay = new Date(currentDay.getFullYear(), 0, d - 6, 0, 0, 0)


      if (weekValue == weekNumber) {
        isPresent = true
      }
      var data = {}
      data = {
        // value: isPresent ? `Week ${weekValue} (Current)` : `Week #${weekValue}`,
        value: `${moment(firstDay).format('MMM D')} - ${moment(lastDay).format('MMM D')}`,
        isPresent: isPresent,
        sunDateTime: Math.floor(Date.parse(lastDay) / 1000),
        monDateTime: Math.floor(Date.parse(firstDay) / 1000),
        firstDay: firstDay,
        lastDay: lastDay,
        dashBoardId: `200${i}`,
        firstDateFormat: `${moment(firstDay).format('DD/MM/YYYY')}`,
        lastDateFormat: `${moment(lastDay).format('DD/MM/YYYY')}`
      }
      res.push(data)
    }

    return res
  },

  daysTotalOrganizer(num) {
    return parseInt(num) < 10 ? `0${num}` : num
  },

  formatTotal(figure) {
    var money = figure.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return `$${money.replace('-', '')}`
  },

  getDayName(day) {
    const dayName = ['', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
    return dayName[day]
  },

  getVariance(target, actual) {
    var totalText = ''
    target = target ? target : 0
    actual = actual ? actual : 0
    var variance = target - actual
    if (variance == 0) {
      totalText = `${this.formatTotal(variance)}`
    }
    else if (variance < 0) {
      totalText = `-${this.formatTotal(variance)}`
    } else {
      totalText = `+${this.formatTotal(variance)}`
    }

    return totalText
  },

  checkValue(value) {
    return value && value != '' ? value : 0;
  },

  checkCashupValueExists(value) {
    return value && value != '' ? value : '';
  },

  checkValueExists(value) {
    return value && value != '' ? value.toFixed(2) : null;
  },

  checkValueExistsZero(value) {
    return value && value != '' ? value.toFixed(2) : 0;
  },

  nullToZero(value) {
    return value ? value.toFixed(2) : 0
  },

  calculateSum(object) {
    var overallList = Object.values(object)
    var totalOverAll = overallList.reduce((a, b) => {
      return a + b
    }, 0)

    return totalOverAll
  },

  addDaysToDate(dateString, daysToAdd, timezone, format = 'yyyy-MM-DD') {
    const momentDate = moment.tz(dateString, timezone);
    momentDate.add(daysToAdd, 'days');
    return momentDate.format(format);
  },

  getCurrentDate(current, dailyTrendDay, timeZone, format = 'yyyy-MM-DD') {
    var weekname = Utils.getWeekname(current.day)
    var dashBoardId = current.dashBoardId
    var monDateTime = current.monDateTime
    var sunDateTime = current.sunDateTime
    var convertDate = new Date(monDateTime * 1000)
    convertDate = Utils.dateTimeGeneratorWithoutFormat(convertDate, timeZone)._d
    var day = dailyTrendDay ? dailyTrendDay : 7
    convertDate = new Date(convertDate)
    convertDate.setDate(convertDate.getDate() + (day - 1))
    return moment_tz(convertDate).format(format)
  },

  getWeeks(currentDate) {
    // Use moment to get ISO week number (Monday-Sunday weeks)
    return moment(currentDate).isoWeek();
  },

  getPeriodName(lastHr) {
    var period = ''
    if (lastHr <= 11) {
      period = 'BREAKFAST'
    } else if (lastHr >= 12 && lastHr <= 16) {
      period = 'LUNCH'
    } else {
      period = 'DINNER'
    }

    return period
  },

  sortArrayItem(array) {
    array = array.sort((a, b) => {
      return a - b
    })

    return array
  },

  checkPastmidnight(openingList) {
    if (openingList.length) {
      var venueTime = openingList.map((n) => {
        var time = n.openTime.split(',')

        return time
      })

      var isPastMidnight = venueTime.filter((res) => {
        return res.length > 1
      })

      if (isPastMidnight.length) {
        return true
      } else {
        return false
      }

      // var pastMidnight = venueTime
      // var timeList = {}

      // timeList = pastMidnight.map((n) => {
      //     var opening = n[0]
      //     opening = opening.split(' - ').shift()

      //     var closing = n.length > 1 ? n.pop() : n.shift()
      //     closing = closing.split(' - ').pop()

      //     var openType = opening.split(' ').pop()
      //     var closeType = closing.split(' ').pop()

      //     var openingTime = opening.split(' ').shift()
      //     var closingTime = closing.split(' ').shift()

      //     var openingExtracted = openingTime.split(':').shift()
      //     var closingExtracted = closingTime.split(':').shift()
      //     openingTime = openType == 'am' || openType == 'pm' && parseInt(openingExtracted) == 12 ? parseInt(openingExtracted) : parseInt(openingTime.split(':').shift()) + 12
      //     closingTime = closeType == 'am' || closeType == 'pm' && parseInt(closingExtracted) == 12 ? parseInt(closingExtracted) : parseInt(closingTime.split(':').shift()) + 12
      //     return {
      //         open: openingTime ? openingTime : 0,
      //         close: closingTime ? closingTime : 0,
      //         openStr: opening,
      //         closeStr: closing
      //     }

      // })

      // var sortOpening = timeList.map((res) => {
      //     return res.open
      // })

      // var sortClosing = timeList.map((res) => {
      //     return res.close
      // })
      // var startingTime = this.sortArrayItem(sortOpening)
      // var closingTime = []

      // closingTime = this.sortArrayItem(sortClosing)
      // if (isPastMidnight.length) {
      //     closingTime = closingTime.filter((res) => {
      //         return res < 5
      //     })
      // }
      // startingTime = startingTime.shift() - 1
      // closingTime = closingTime.pop()

      // var periodicTime = []
      // while(startingTime != closingTime) {
      //     if (startingTime >= 24) {
      //         startingTime = startingTime - 24
      //     }
      //     startingTime++
      //     periodicTime.push(startingTime)
      // }

      // return periodicTime
    }
  },

  getTotal(value, qty) {
    var total = value * qty

    if (!total) {
      total = null
    }
    return total
  },

  getRollCount(limit, qty) {

    var quantity = qty ? qty : null
    var rolls = null
    if (limit && quantity) {
      rolls = quantity / limit

      var remaining = (rolls * 10)
      remaining = remaining % 10

      if (remaining) {
        rolls += 1
      }

    }
    return `${rolls ? ~~rolls : ''}`
  },

  calculateWeeks(option) {
    var weekSelected = option.current
    var currentWeek = option.list.find((n) => n.value == option.current)
    var previousWeek = moment_tz(currentWeek.monDateTime * 1000).tz('Australia/sydney')

    var day = previousWeek.day()
    if (day < option.weekStart) {
      previousWeek = moment_tz(previousWeek).tz('Australia/sydney').add(-1, 'week')
    }

    var tempCurrentWeek = moment_tz(previousWeek).tz('Australia/sydney').add(+1, 'week')
    var data = []

    for (var i = option.weekStart; i <= 7; i++) {
      var time = ''
      if (i == 1) {
        time = moment_tz(previousWeek).tz('Australia/sydney').format('MMM DD')
      } else {
        time = moment_tz(previousWeek).tz('Australia/sydney').add(i - 1, 'days').format('MMM DD')
      }
      data.push({
        day: this.getDayName(i),
        week: i,
        time: time
      })
    }
    for (var i = 1; i < option.weekStart; i++) {
      var time = ''
      if (i == 1) {
        time = moment_tz(tempCurrentWeek).tz('Australia/sydney').format('MMM DD')
      } else {
        time = moment_tz(tempCurrentWeek).tz('Australia/sydney').add(i - 1, 'days').format('MMM DD')
      }
      data.push({
        day: this.getDayName(i),
        week: i,
        time: time
      })
    }

    return data

  },

  dayHeadOrganizer(weekStart, day) {
    const dayName = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    var start = weekStart + day
    if (start > 7) {
      start = start - 7
    }
    var name = dayName[start]
    return name

  },
  removeCurrencySymbol(amount) {
    var currency = amount ? amount.toString() : ''

    if (currency != '') {
      currency = currency.replace('\$', '').replace(',', '')
    } else {
      currency = 0;
    }


    return currency

  },

  getWeekList(weeks = 2) {
    var currentDate = moment()
    var lists = []
    for (var i = 1; i <= weeks; i++) {
      var obj = {}
      currentDate = moment().subtract(i, 'week')
      var weekend = currentDate.clone().endOf('isoWeek');
      weekend = new Date(weekend)
      obj.cycle = moment_tz(weekend).format('DD-MMM-yyyy')
      obj.mon = { cost: 0, isAvgCost: false }
      obj.tue = { cost: 0, isAvgCost: false }
      obj.wed = { cost: 0, isAvgCost: false }
      obj.thu = { cost: 0, isAvgCost: false }
      obj.fri = { cost: 0, isAvgCost: false }
      obj.sat = { cost: 0, isAvgCost: false }
      obj.sun = { cost: 0, isAvgCost: false }
      obj.total = 0
      lists.push(obj)
    }

    return lists
  },

  getGraphFlatLine(type = 'label') {
    var data = []
    for(var i = 6; i <= 23; i++) {
      var label = i.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })
      var totalMinute = 0
      for (var cnt = 0; cnt <= 3; cnt++) {
        if (type == 'label') {
          totalMinute = totalMinute.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })
          data.push(`${label}:${totalMinute}`)
          totalMinute = parseInt(totalMinute) + 15
        } else {
          data.push(0)
        }
      }
    }

    return data
  },

  removeCommaInNumbers(number) {
    number = parseFloat(number.replace(/,/g, ''));
    return number
  },

  percentageTotal(purchases, revenue) {
    if (purchases == '') {
      return ''
    }
    if (revenue <= 0 || purchases > revenue) {
        return '100%'
      } else {
        var totalPercentage = purchases / revenue * 100
        return `${totalPercentage.toFixed(1)}%`
      }
  },

  /**
   * Safely get a value, returning null if it's null, undefined, or the string 'undefined'
   * @param {*} value - The value to check
   * @param {*} defaultValue - Optional default value to return if the check fails
   * @returns {*} The original value if valid, otherwise null or the default value
   */
  safeValue(value, defaultValue = null) {
    return value === 'undefined' || value === null || value === undefined ? defaultValue : value;
  },

}







// WEBPACK FOOTER //
// ./src/utils/utils.js